/**
 * @desc 库存动作分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.inventorySummaryPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/inventorySummaryPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
